import { contextFactory } from '@frontend/design-system';
import { UseWritebackCapabilitiesResults } from './useWritebackCapabilities';

export const [DigitalFormsWritebackCapabilitiesContext, useDigitalFormsWritebackCapabilitiesContext] =
  contextFactory<UseWritebackCapabilitiesResults>(
    'useDigitalFormsWritebackCapabilitiesContext must be used within a DigitalFormsWritebackCapabilitiesContext'
  );
